/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  PostTokenValidate200Response,
  RevokeTokenReq,
  ValidateTokenReq,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    PostTokenValidate200ResponseFromJSON,
    PostTokenValidate200ResponseToJSON,
    RevokeTokenReqFromJSON,
    RevokeTokenReqToJSON,
    ValidateTokenReqFromJSON,
    ValidateTokenReqToJSON,
} from '../models';

export interface PostTokenRevokeRequest {
    revokeTokenReq: RevokeTokenReq;
    slashIDSdkVersion?: string;
    slashIDRequiredConsistency?: PostTokenRevokeSlashIDRequiredConsistencyEnum;
    slashIDRequiredConsistencyTimeout?: number;
}

export interface PostTokenValidateRequest {
    validateTokenReq: ValidateTokenReq;
    slashIDSdkVersion?: string;
}

/**
 * 
 */
export class TokensApi extends runtime.BaseAPI {

    /**
     * This endpoint revokes a SlashID user token. 
     * Revoke a user token
     */
    async postTokenRevokeRaw(requestParameters: PostTokenRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.revokeTokenReq === null || requestParameters.revokeTokenReq === undefined) {
            throw new runtime.RequiredError('revokeTokenReq','Required parameter requestParameters.revokeTokenReq was null or undefined when calling postTokenRevoke.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (requestParameters.slashIDRequiredConsistency !== undefined && requestParameters.slashIDRequiredConsistency !== null) {
            headerParameters['SlashID-Required-Consistency'] = String(requestParameters.slashIDRequiredConsistency);
        }

        if (requestParameters.slashIDRequiredConsistencyTimeout !== undefined && requestParameters.slashIDRequiredConsistencyTimeout !== null) {
            headerParameters['SlashID-Required-Consistency-Timeout'] = String(requestParameters.slashIDRequiredConsistencyTimeout);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/token/revoke`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevokeTokenReqToJSON(requestParameters.revokeTokenReq),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint revokes a SlashID user token. 
     * Revoke a user token
     */
    async postTokenRevoke(requestParameters: PostTokenRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postTokenRevokeRaw(requestParameters, initOverrides);
    }

    /**
     * This endpoint validates a SlashID user token. The response indicates whether the token is valid and its expiration time if so. If the token is not valid, the reason is returned. 
     * Validate a user token
     */
    async postTokenValidateRaw(requestParameters: PostTokenValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostTokenValidate200Response>> {
        if (requestParameters.validateTokenReq === null || requestParameters.validateTokenReq === undefined) {
            throw new runtime.RequiredError('validateTokenReq','Required parameter requestParameters.validateTokenReq was null or undefined when calling postTokenValidate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/token/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateTokenReqToJSON(requestParameters.validateTokenReq),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostTokenValidate200ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint validates a SlashID user token. The response indicates whether the token is valid and its expiration time if so. If the token is not valid, the reason is returned. 
     * Validate a user token
     */
    async postTokenValidate(requestParameters: PostTokenValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostTokenValidate200Response> {
        const response = await this.postTokenValidateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const PostTokenRevokeSlashIDRequiredConsistencyEnum = {
    LocalRegion: 'local_region',
    AllRegions: 'all_regions'
} as const;
export type PostTokenRevokeSlashIDRequiredConsistencyEnum = typeof PostTokenRevokeSlashIDRequiredConsistencyEnum[keyof typeof PostTokenRevokeSlashIDRequiredConsistencyEnum];
